import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { FormComponent, FormsComponent } from '../interfaces';
import { UnsavedChangesService } from '../services/unsaved-changes.service';

export const UnsavedChangesGuard: CanDeactivateFn<FormComponent|FormsComponent> = (component) =>  {

    const unsavedChangesService = inject(UnsavedChangesService);

    if ('form' in component) {
        if (component['form'].dirty) {
            return unsavedChangesService.openDialog(true);
        }
    } else if ('forms' in component) {
        let hasDirtyForm = false;
        for (let form of component['forms']) {
            if (form && form.dirty) {
                hasDirtyForm = true;
                break;
            }
        }
        if (hasDirtyForm) {
            return unsavedChangesService.openDialog(true);
        }
    }
    return true;
}
